<template>
    <frontend-layout>
        <div class="container mx-auto mb-16 max-w-4xl text-center">
            <div
                class="mb-4 mt-12 text-[36px] font-semibold md:text-[40px] lg:text-[56px]"
            >
                All-Inclusive Membership
            </div>
            <div class="mt-4 leading-loose">
                Our membership includes everything we have to offer — 7,000+
                quiz questions, thousands of flashcards, 400+ video-based
                lectures, and much, much more.
            </div>
        </div>

        <div class="m-4 md:m-0">
            <div
                class="mx-auto flex w-auto max-w-[50rem] flex-col justify-between gap-4 md:mb-0 md:flex-row"
            >
                <div
                    class="flex w-full flex-col rounded border border-gray-200 bg-gray-50 p-8 text-center text-[18px] md:h-[22rem] md:w-[24rem]"
                >
                    <div
                        class="mb-4 border-b border-gray-200 pb-4 font-semibold"
                    >
                        Monthly Membership
                    </div>
                    <div class="">
                        Monthly auto-renew, billed every month. Cancel anytime.
                    </div>
                    <div
                        class="mb-auto mt-auto flex items-center justify-center gap-1"
                    >
                        <span class="text-[36px] font-semibold">$39</span
                        ><span>/month</span>
                    </div>
                    <div class="mt-auto">
                        <span @click="goToRegistration('price_1K1hNBG3PtJ4DQowWFEf6mhu')"
                              class="btn btn-lg btn-primary"
                        >
                            Get started (monthly)
                        </span>
                    </div>
                </div>
                <div
                    class="rounded bg-gray-900 text-center text-[18px] text-white md:h-[22rem] md:w-[24rem]"
                >
                    <div
                        class="flex h-full w-full flex-col rounded border-[3px] border-primary-400 p-8"
                    >
                        <div
                            class="mb-4 border-b border-gray-800 pb-4 font-semibold"
                        >
                            Annual Membership
                        </div>
                        <div class="">
                            Membership for 1 year. One-time payment.
                            <span class="text-secondary-500">Save 35%</span>.
                        </div>
                        <div
                            class="mb-auto mt-auto flex items-center justify-center gap-1"
                        >
                            <span class="text-[36px] font-semibold">$299</span
                            ><span>/year</span>
                        </div>
                        <div class="mt-auto">
                            <span
                                @click="goToRegistration('price_1K1hLcG3PtJ4DQowPFfkAkVx')"
                                class="btn btn-lg border-dark-mode-stroke bg-dark-mode-fill hover:bg-dark-mode-highlight"
                            >
                                Get started (1 year)
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="my-20">
            <a :href="$page.props.site_config.backend_app_activation_code_signup_route">
                <div
                    class="flex items-center justify-center gap-2 text-[18px] text-gray-800"
                >
                    <div class="">I already have an activation code</div>
                    <div class="">
                        <svg
                            width="22"
                            height="23"
                            viewBox="0 0 22 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11 20.6668C16.0626 20.6668 20.1667 16.5628 20.1667 11.5002C20.1667 6.43755 16.0626 2.3335 11 2.3335C5.93738 2.3335 1.83333 6.43755 1.83333 11.5002C1.83333 16.5628 5.93738 20.6668 11 20.6668Z"
                                stroke="#0093F2"
                                stroke-width="1.83333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M11 15.1668L14.6667 11.5002L11 7.8335"
                                stroke="#0093F2"
                                stroke-width="1.83333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M7.33333 11.5H14.6667"
                                stroke="#0093F2"
                                stroke-width="1.83333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                </div>
            </a>

        </div>

        <div class="bg-gray-900 py-20">
            <div class="container max-w-4xl text-center text-white">
                <div class="mb-6 text-[40px] font-semibold">
                    Membership Includes
                </div>
                <div class="mb-8 text-[20px]">
                    Our memberships include
                    <span class="text-secondary-500"
                    >everything we have to offer</span
                    >
                    (along with access to all future updates while your
                    membership is active)
                </div>
                <div class="text-gray-500">
                    <!--                    <div-->
                    <!--                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"-->
                    <!--                    >-->
                    <!--                        <svg-->
                    <!--                            width="22"-->
                    <!--                            height="22"-->
                    <!--                            viewBox="0 0 22 22"-->
                    <!--                            fill="none"-->
                    <!--                            xmlns="http://www.w3.org/2000/svg"-->
                    <!--                        >-->
                    <!--                            <circle cx="11" cy="11" r="11" fill="#26B277" />-->
                    <!--                            <path-->
                    <!--                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"-->
                    <!--                                stroke="white"-->
                    <!--                                stroke-width="1.83333"-->
                    <!--                            />-->
                    <!--                        </svg>-->
                    <!--                                                <div class="">-->
                    <!--                                                    <span class="font-semibold text-white"-->
                    <!--                                                        >Adaptive Simulation:</span-->
                    <!--                                                    >-->
                    <!--                                                    An adaptive simulation test that mimics the NREMT-->
                    <!--                                                    exam-->
                    <!--                                                </div>-->
                    <!--                    </div>-->
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Assessment Quiz:</span
                            >
                            A ~30 minute quiz that tells us your strengths &
                            weaknesses
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Practice Questions:</span
                            >
                            7,000+ practice questions (Including updated TEI
                            questions)
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Targeted Quizzes:</span
                            >
                            Quizzes that combine questions from your weak areas
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Video Lessons:</span
                            >
                            400+ hrs of video lessons and animations
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Livestreams:</span
                            >
                            Weekly livestreams with certified instructors
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Flashcards:</span
                            >
                            Thousands of flashcards covering all NREMT topics
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Unlimited Access:</span
                            >
                            Unlimited access to all our materials
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Content Updates:</span
                            >
                            Content updated to meet 2023 standards (new content
                            added weekly)
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >All Levels:</span
                            >
                            Covers EMR, EMT, AEMT, and Paramedic
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Pass Guarantee:</span
                            >
                            Extend your membership for free if you don’t pass
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >Study Guides:</span
                            >
                            Study guides to help you refresh any missing
                            knowledge
                        </div>
                    </div>
                    <div
                        class="mb-4 flex items-center justify-start gap-4 rounded bg-dark-mode-fill p-6 text-left"
                    >
                        <svg
                            width="22"
                            height="22"
                            viewBox="0 0 22 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle cx="11" cy="11" r="11" fill="#26B277"/>
                            <path
                                d="M6 11.3778C7.88694 12.6815 10.6316 14.6044 10.6316 15.7778C11.4893 12.8444 13.7193 6.78222 15.7778 6"
                                stroke="white"
                                stroke-width="1.83333"
                            />
                        </svg>
                        <div class="">
                            <span class="font-semibold text-white"
                            >No downloads required:</span
                            >
                            EMTprep utilizes responsive designs that work on all
                            devices
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container max-w-screen-lg px-4 pt-8 md:pt-16 lg:px-0">
            <div
                class="flex flex-col items-start lg:flex-row lg:justify-between"
            >
                <div
                    class="my-4 w-full flex-none pb-12 text-center text-[34px] font-semibold capitalize lg:w-96 lg:text-left"
                >
                    Frequently Asked&nbsp;Questions (FAQs)
                </div>
                <div class="mb-8 md:mb-16">
                    <expanding-text-block
                        v-for="faqQuestion in faqQuestions"
                        :question="faqQuestion.question"
                        :answer="faqQuestion.answer"
                    />

                    <div class="mt-8">
                        <Link class="link" :href="route('frontend.faqs')"
                        >See all FAQs
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import ExpandingTextBlock from "@/Components/ExpandingTextBlock";
import ActivationCodeModal from "@/Components/ActivationCodeModal";

export default {
    name: "Pricing",
    components: {ActivationCodeModal, FrontendLayout, ExpandingTextBlock},
    props: {
        faqQuestions: {
            type: Array,
            default: [],
        },
    },
    methods: {
        goToRegistration(stripePriceId) {

            let cart
            let registerRoute = this.$page.props.site_config.backend_app_signup_route

            cart = btoa(JSON.stringify([
                {
                    price_id: stripePriceId,
                    qty: 1
                }
            ]))

            registerRoute += '?cart=' + cart

            window.location = registerRoute
        }
    },
};
</script>
